import { render, staticRenderFns } from "./ProposalAddresses.vue?vue&type=template&id=395534a9&scoped=true&"
import script from "./ProposalAddresses.vue?vue&type=script&lang=js&"
export * from "./ProposalAddresses.vue?vue&type=script&lang=js&"
import style0 from "./ProposalAddresses.vue?vue&type=style&index=0&id=395534a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395534a9",
  null
  
)

component.options.__file = "ProposalAddresses.vue"
export default component.exports